import * as React from 'react';
import {FunctionComponent, useState} from 'react';
// @ts-ignore
import {SingleDatePicker} from 'react-dates-gte-react-17';
import moment = require('moment');

interface OwnProps {
    date: Date | null;
    onChange: (date: Date | null) => void;
}

export const DatePicker: FunctionComponent<OwnProps> = ({date, onChange}) => {
    const [focusedInput, setFocusedInput] = useState<boolean>(false);

    return (
        <div className="datepicker">
            <SingleDatePicker
                displayFormat="DD-MM-YYYY"
                date={moment(date)}
                focused={focusedInput}
                onDateChange={(d: Date) => onChange(d)}
                onFocusChange={(e: any) => setFocusedInput(e.focused)}
            />
        </div>
    );
};
